import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class DepartmentQuailtyD01 extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    manual: PropTypes.object.isRequired,
  };
  state = {};

  /////////////////////////////////////////////////////////////
  render() {
    return <div></div>;
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DepartmentQuailtyD01);
